import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import Footer from "./components/FooterNew/index.js";
import PRJsonData from "./components/wholesale-lending-pr.json";
import { Helmet } from "react-helmet";
import SpanishPRJsonData from "./components/Spanish-wholesale-lending-pr.json";

// Lazy-loaded components
const Lodetails = lazy(() => import("./components/Lodetails/lodetails.js"));
const Presence = lazy(() => import("./components/Presence/presence.js"));
const ProductSection = lazy(() => import("./components/ProductSection/product.js"));
const Presentations = lazy(() => import("./components/Presentation/presentation.js"));
const LogoSection = lazy(() => import("./components/Logo Section/NewLogoSection.js"));
const TableData = lazy(() => import("./components/Table/table.js"));
const Testimonials = lazy(() => import("./components/Testimonials/testimonial.js"));
const SWMCBroker = lazy(() => import("./components/SWMCBroker/swmcbroker.js"));
const FAQ = lazy(() => import("./components/FAQ/faq.js"));

function App() {
  const { agentName } = useParams();
  const [isSpanish, setIsSpanish] = useState(false); // Default to English
  const toggleLanguage = () => {
    setIsSpanish(!isSpanish); // Toggle the language state
  };
  
  const handleLanguageChange = (isSpanish) => {
    setIsSpanish(isSpanish);
  };

const fetchData = async () => {
  try {
    const jsonData = isSpanish
      ? await import("./components/Spanish-wholesale-lending-pr.json")
      : await import("./components/wholesale-lending-pr.json");

    // Set state variables based on the fetched JSON data
    setBannerData(jsonData.bannerData);
    setPresenceData(jsonData.presenceData);
    setProductData(jsonData.productData);
    setLogoData(jsonData.logoData);
    setTableData(jsonData.tableData);
    setTestimonialData(jsonData.testimonialData);
    setBrokerData(jsonData.brokerData);
    setFaqData(jsonData.faqData);


    
    // Other data setting logic...
  } catch (error) {
    console.error("Error fetching data:", error);
    setError("Error fetching data");
  }
};

useEffect(() => {
  fetchData(); // Fetch JSON data based on the language toggle
}, [isSpanish]); // Add isSpanish to the dependency array

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [loanOfficerData, setLoanOfficerData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [bannerData, setBannerData] = useState(); // State for bannerData
  const [presenceData, setPresenceData] = useState(); // State for bannerData
  const [productData, setProductData] = useState(); // State for bannerData
  const [logoData, setLogoData] = useState(); // State for bannerData
  const [tableData, setTableData] = useState(); // State for bannerData
  const [testimonialData, setTestimonialData] = useState(); // State for bannerData
  const [brokerData, setBrokerData] = useState(); // State for bannerData
  const [faqData, setFaqData] = useState(); // State for bannerData

  // Function to handle loan officer click
  const handleLoanOfficerClick = (loanOfficerData) => {
    setLoanOfficerData(loanOfficerData);
    setLoanOfficerActive(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Simulate fetching data (replace with actual fetching logic)
        // In this example, we set the bannerData after a delay to simulate data fetching
        await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate delay
        setBannerData(PRJsonData.bannerData); // Set bannerData from PRJsonData
        setPresenceData(PRJsonData.presenceData); // Set bannerData from PRJsonData
        setProductData(PRJsonData.productData); // Set bannerData from PRJsonData
        setLogoData(PRJsonData.logoData); // Set bannerData from PRJsonData
        setTableData(PRJsonData.tableData); // Set bannerData from PRJsonData
        setTestimonialData(PRJsonData.testimonialData); // Set bannerData from PRJsonData
        setBrokerData(PRJsonData.brokerData); // Set bannerData from PRJsonData
        setFaqData(PRJsonData.faqData); // Set bannerData from PRJsonData

        // Additional data fetching and setting state logic goes here...

        setLoading(false); // Set loading to false after data fetching
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Error fetching data"); // Set error state
        setLoading(false); // Set loading to false on error
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bodyContainer">
         {/* <Helmet>
      <title>Sun West Mortgage - Making Homeownership a Breeze!</title>
      <meta name="description" content="Find your true home with Sun West Mortgage Company, an industry leading financial enablement backed by top-notch technology. Purchase or refinance your home with us today and experience our commitment to client satisfaction, low rates, cost savings and great service." />
      <meta
        name="keywords"
        content="Sun West, Sun West Mortgage, Mortgage, Loan Tools, Lender, Loan, Home Loan, True Home, Purchase, Refinance, Loan Origination, Mortgage Payment Support Services, TRU Approval, AngelAi, The Processor, 24/7, AI Assistant, Deals, Underwriting, Instant Underwriting, Transformative Technology, Approvals, Condition Review, Loan Servicing, Mortgage AI, Realtor AI, Real estate AI, Personal assistant ai, AI personal assistant, AskAngel.Ai, AskAngel"
      />
      <meta property="og:title" content="Sun West Mortgage - Making Homeownership a Breeze!" />
      <meta property="og:description" content="Find your true home with Sun West Mortgage Company, an industry leading financial enablement backed by top-notch technology. Purchase or refinance your home with us today and experience our commitment to client satisfaction, low rates, cost savings and great service." />
      <meta name="image" property="og:image" content="https://resources.swmc.com/swmc-images/WholesaleLending/PR/English.jpg" />
      <meta property="og:type" content="website" />
    </Helmet> */}
      <Suspense fallback={<Spinner animation="border" />}>
        {error && <Alert variant="danger">{error}</Alert>}
        {loading ? (
          <div className="mt-5 mb-3 text-center">
            <Spinner animation="border" />
            <h5>Loading...</h5>
          </div>
        ) : (
          <>
            <Header
  toggleLanguage={toggleLanguage} // Use toggleLanguage instead of handleLanguageChange
  handleLanguageChange={handleLanguageChange} // Pass handleLanguageChange
  loanOfficerActive={loanOfficerActive}
  loanOfficerData={loanOfficerData}
  angelAiUserInfo={angelAiUserInfo}
/>
            <Body
              bannerData={bannerData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Presence
              presenceData={presenceData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <ProductSection
              productData={productData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <TableData
              tableData={tableData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <LogoSection // Changed component name to avoid conflict
              logoData={logoData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Testimonials
              testimonialData={testimonialData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <SWMCBroker
              brokerData={brokerData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <FAQ
              faqData={faqData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Footer />
          </>
        )}
      </Suspense>
    </div>
  );
}

export default App;
